import { render, staticRenderFns } from "./Historics.vue?vue&type=template&id=c02dd2c8&scoped=true&"
import script from "./Historics.vue?vue&type=script&lang=js&"
export * from "./Historics.vue?vue&type=script&lang=js&"
import style0 from "./Historics.vue?vue&type=style&index=0&id=c02dd2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02dd2c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
